module.exports = __webpack_public_path__ + "img/document-generator-empty.0ade89fd.png";